/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

/**
 * @description generated: list of files importing the export below
 *
 *
 * @link file://./../../bundles/learner-progress/components/item/week/private/WeekItemAnnotations.tsx
 */
export { default as WidgetItem } from './components/cds/WidgetItem';
export const WidgetItemDynamic = () => import('./components/cds/WidgetItem');

/**
 *  #################################### Generated content ####################################
 **/
